import { MetaFieldType } from "src/app/methods/getMetaFieldTypeOptions";

export const actionPredefinedFilters = [
  {
    name: "Actions",
    uuid: "predefined-filter-actions",
    data: {
      singleSelectOptions: [
        {
          value: "completed",
          name: "Completed",
          label: "Completed",
        },
        {
          value: "incompleted",
          name: "Incompleted",
          label: "Incompleted",
        },
        {
          value: "my_actions",
          name: "My Actions",
          label: "My Actions",
        },
      ],
    },
    type: MetaFieldType.SingleSelect,
  },
];
